export default __webpack_public_path__ + "static/media/finger.6f8b057f.png";